module.exports = __webpack_public_path__ + "img/nav-alt.f874d19f.svg";